import { createContext } from 'react';

export const NavbarSlotContext = createContext({ slot: null, setSlot: () => {} });
